import React from 'react';

// Small fixed badge indicating the build tool (vite/webpack)
export const BuildToolBadge: React.FC = () => {
  if (NODE_ENV === 'prod') return null;

  const style: React.CSSProperties = {
    position: 'fixed',
    bottom: '6px',
    right: '6px',
    padding: '2px 6px',
    borderRadius: '4px',
    background: BUILD_TOOL === 'vite' ? '#7c3aed' : '#2d3748',
    color: '#ffffff',
    fontSize: '10px',
    fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, sans-serif',
    opacity: 0.6,
    zIndex: 9999,
    pointerEvents: 'none',
  };

  return <div style={style}>{BUILD_TOOL}</div>;
};
